import React, { useState } from "react";
import { Clapperboard, Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PublicVideoShell, PublicVideoState } from "@/components/tutorials/PublicVideoShell";
import { PublicVideoCard } from "@/components/tutorials/PublicVideoCard";
import { PUBLIC_VIDEO_BRAND, usePublicVideos, VIDEO_GROUPS, videoGroup } from "@/lib/publicTutorials";

export default function PublicVideoLibrary() {
  const { data, loading, error, reload } = usePublicVideos();
  const [group, setGroup] = useState("all");
  const [search, setSearch] = useState("");
  const items = data?.items || [];
  const visible = items.filter(item => (group === "all" || videoGroup(item) === group)
    && `${item.title} ${VIDEO_GROUPS[videoGroup(item)]}`.toLowerCase().includes(search.trim().toLowerCase()));
  const groups = { all: "All videos", ...VIDEO_GROUPS };
  return <PublicVideoShell>
    <div className="pv-page-heading"><div><p className="pv-eyebrow" data-testid="video-library-eyebrow">{PUBLIC_VIDEO_BRAND}</p>
      <h1 data-testid="video-library-title">Video library<span className="pv-heading-dot">.</span></h1></div>
      {!loading && !error && <span className="pv-total" data-testid="video-library-total"><Clapperboard size={17} />{items.length} {items.length === 1 ? "video" : "videos"}</span>}
    </div>
    {loading || error ? <PublicVideoState loading={loading} error={error} reload={reload} /> : <>
      <div className="pv-toolbar">
        <div className="pv-filters" role="group" aria-label="Video audience" data-testid="video-library-filters">
          {Object.entries(groups).map(([key, label]) => <button key={key} type="button" aria-pressed={group === key} onClick={() => setGroup(key)} data-testid={`video-filter-${key}`}>
            {label}<span data-testid={`video-filter-count-${key}`}>{key === "all" ? items.length : items.filter(item => videoGroup(item) === key).length}</span>
          </button>)}
        </div>
        <div className="pv-search"><Search size={17} aria-hidden="true" /><Input value={search} onChange={event => setSearch(event.target.value)} placeholder="Find a video" aria-label="Find a video" data-testid="video-library-search" /></div>
      </div>
      {visible.length ? <div className="pv-grid" data-testid="video-library-grid">{visible.map((item, index) => <PublicVideoCard key={`${item.audience}:${item.section}`} item={item} index={index} />)}</div>
        : <div className="pv-state" data-testid="video-library-empty"><Clapperboard size={32} /><h2 data-testid="video-library-empty-title">{items.length ? "No matching videos" : "No videos yet"}</h2>
          <p data-testid="video-library-empty-message">{items.length ? "Try another audience or search." : "Uploaded tutorials will appear here."}</p>
          {!!items.length && <Button variant="outline" onClick={() => { setGroup("all"); setSearch(""); }} data-testid="video-library-reset-filters"><X className="mr-2 h-4 w-4" />Clear filters</Button>}
        </div>}
    </>}
  </PublicVideoShell>;
}